import { render, staticRenderFns } from "./ChallengeView.vue?vue&type=template&id=2783a069"
import script from "./ChallengeView.vue?vue&type=script&lang=js"
export * from "./ChallengeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports